import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

const CATS = ["iPhone", "iPad", "MacBook", "iMac"];

export default function Catalog() {
  const [params, setParams] = useSearchParams();
  const activeCat = params.get("kategori") || "";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/products", { params: activeCat ? { category: activeCat } : {} })
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, [activeCat]);

  const setCat = (c) => {
    if (c) setParams({ kategori: c });
    else setParams({});
  };

  return (
    <div className="tk-container py-16" data-testid="catalog-page">
      <p className="tk-overline mb-3">Butikk</p>
      <h1 className="text-3xl sm:text-4xl font-semibold mb-2">Apple-reservedeler</h1>
      <p className="text-sm text-slate-500 mb-10 max-w-xl">
        Velg kategori og finn riktig del for din modell. Pris inkluderer del — arbeid kommer i tillegg når du velger verksted.
      </p>

      <div className="flex flex-wrap gap-2 mb-10" data-testid="category-filter">
        <button
          onClick={() => setCat("")}
          className={`px-4 py-2 rounded-md text-sm border ${!activeCat ? "bg-[#0B1C30] text-white border-[#0B1C30]" : "border-[#E2E8F0] bg-white text-slate-700 hover:bg-slate-50"}`}
          data-testid="filter-all"
        >
          Alle
        </button>
        {CATS.map((c) => (
          <button
            key={c}
            onClick={() => setCat(c)}
            className={`px-4 py-2 rounded-md text-sm border ${activeCat === c ? "bg-[#0B1C30] text-white border-[#0B1C30]" : "border-[#E2E8F0] bg-white text-slate-700 hover:bg-slate-50"}`}
            data-testid={`filter-${c.toLowerCase()}`}
          >
            {c}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="text-slate-500">Laster …</p>
      ) : products.length === 0 ? (
        <p className="text-slate-500">Ingen produkter funnet.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((p) => (
            <Link
              to={`/produkt/${p.id}`}
              key={p.id}
              className="tk-card tk-card-interactive !p-0 overflow-hidden block"
              data-testid={`product-card-${p.id}`}
            >
              <div className="aspect-[4/3] bg-slate-100 overflow-hidden border-b border-[#E2E8F0]">
                {p.image ? (
                  <img src={p.image} alt={p.name} className="w-full h-full object-cover" />
                ) : null}
              </div>
              <div className="p-6">
                <p className="tk-overline mb-2 text-[#4A7C59]">{p.category}</p>
                <h3 className="text-lg font-semibold mb-1 leading-snug">{p.name}</h3>
                <p className="text-xs text-slate-500 mb-4">
                  Passer: {(p.compatible_models || []).join(", ")}
                </p>
                <div className="flex items-end justify-between">
                  <div>
                    <p className="text-xs text-slate-400">Fra</p>
                    <p className="text-xl font-semibold">kr {p.price.toFixed(0)}</p>
                  </div>
                  <span className={`text-xs px-2 py-1 rounded-md ${p.stock_quantity > 0 ? "bg-emerald-50 text-emerald-700" : "bg-red-50 text-red-700"}`}>
                    {p.stock_quantity > 0 ? "På lager" : "Utsolgt"}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
